import { Component } from '@angular/core';
import { values } from 'lodash';
import { TranslationService } from '@app/core/_base/layout';
@Component({
  selector: 'kt-set-language',
  templateUrl: './set-language.component.html',
  styleUrls: ['./set-language.component.scss'],
})
export class SetLanguageComponent {
  selectedCountryId = 0;
  selectedCurrency = 0;
  listCountries = [
    { id: 0, name: 'VietNam', value: 'vi' },
    { id: 1, name: 'Chinese', value: 'ch' },
    { id: 2, name: 'English', value: 'en' },
  ];
  listCurrencies = [
    { id: 0, name: 'VND - Vietnamese Dong', value: 'VND' },
    { id: 1, name: 'CNY - Chinese Yuan Renminbi', value: 'CNY' },
    { id: 2, name: 'USD - United States Dollar', value: 'USD' },
  ];

  constructor(private translationService: TranslationService) {}
  ngOnInit() {
    const findItemInlistCountries = this.listCountries.find(
      (item) => item.value === localStorage.getItem('language')
    );
    if (findItemInlistCountries) {
      this.selectedCountryId = findItemInlistCountries.id;
    }
  }
  onCountryChange(id: number) {
    // console.log(id);
    this.selectedCountryId = id;
  }
  onSaveLanguageChange() {
    this.translationService.setLanguage(this.listCountries[this.selectedCountryId].value);
  }
  onCurrencyChange(id) {
    this.selectedCurrency = id;
  }
}
